import { get } from "lodash"

export const getEmails = state => get(state, "global.data.subscriptions.data.emails")
